import * as actions from "./actions";

const initialState = {
	item: null,
	loading: {},
	errors: {}
};

const reducer = function(state = initialState, { type, payload }) {
	switch (type) {
		case actions.CREATE_CONTRACT: {
			return {
				...state,
				loading: { isCreating: true }
			};
		}
		case actions.CREATE_CONTRACT_SUCCESS: {
			return {
				...state,
				loading: { isCreating: false },
				errors: {}
			};
		}
		case actions.CREATE_CONTRACT_ERROR: {
			return {
				...state,
				errors: payload,
				loading: { isCreating: false }
			};
		}

		case actions.SET_VALUE:
			return {
				...state,
				...payload
			};
		case actions.CLEAR_VALUES:
			return {
				...initialState
			};
		default: {
			return state;
		}
	}
};

export default reducer;
